<template>
    <div class="sportFootballMatchStatusPeriodScore">
        <span class="title">Score</span>
        <span class="score">{{ home }} - {{ away }}</span>
    </div>
</template>

<script>
export default {
  name: 'SportFootballMatchStatusPeriodScore',
  props: {
    home: {
      type: Number,
      required: false
    },
    away: {
      type: Number,
      required: false
    }
  },
  computed: {
  }
}
</script>

<style>
.sportFootballMatchStatusPeriodScore > .title{
  position:absolute;
  display:block;
  bottom:100%;
  width:100%;
  text-align:center;
  height:12px;
  line-height: 12px;
  font-size:8px;
}
.sportFootballMatchStatusPeriodScore > .score{
  font-weight:bold;
  font-size:14px
}
</style>
